import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import { MlmProgramContainerModel } from '../../../../../../models/aggregates/erp/mlm-admin';


@Injectable({ providedIn: 'root' })
export class MlmProgramService extends BaseApiTemplateService<MlmProgramContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX  + 'mlm/programs';
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mlm/programs';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX  + 'mlm/programs';
    this.httpClient = theHttp;
  }


}

